export type IAppRegion =
  | 'crowdaa-dev-us'
  | 'crowdaa-preprod-fr'
  | 'crowdaa-us'
  | 'crowdaa-fr';

export type IAppRegionSettings = {
  name: string;
  countryCode: string;
  apiUrl: string;
  rootAppId: string;
  previewUrl: string;
  legacyDashboardUrl: string;
  legacyCrowdUrl: string;
};

export type IAppRegionsSettings = Record<IAppRegion, IAppRegionSettings>;

export const appRegionsSettings: IAppRegionsSettings = {
  'crowdaa-dev-us': {
    name: 'dev-us',
    countryCode: 'us',
    apiUrl: 'https://dev-api.aws.crowdaa.com/v1',
    rootAppId: 'nQ9ZO9DEgfaOzWY44Xu2J2uaPtP92t176PpBkdqu',
    previewUrl: 'https://preview-app-dev-us.crowdaa.com',
    legacyDashboardUrl: 'https://dev-blog.crowdaa.com',
    legacyCrowdUrl: 'https://dev-crowd.crowdaa.com',
  },
  'crowdaa-preprod-fr': {
    name: 'preprod-fr',
    countryCode: 'fr',
    apiUrl: 'https://preprod-api.aws.crowdaa.com/v1',
    rootAppId: 'nQ9ZO9DEgfaOzWY44Xu2J2uaPtP92t176PpBkdqu',
    previewUrl: 'https://preview-app-preprod-fr.crowdaa.com',
    legacyDashboardUrl: 'https://preprod-blog.crowdaa.com',
    legacyCrowdUrl: 'https://preprod-crowd.crowdaa.com',
  },
  'crowdaa-us': {
    name: 'prod-us',
    countryCode: 'us',
    apiUrl: 'https://api.aws.crowdaa.com/v1',
    rootAppId: 'nQ9ZO9DEgfaOzWY44Xu2J2uaPtP92t176PpBkdqu',
    previewUrl: 'https://preview-app-us.crowdaa.com',
    legacyDashboardUrl: 'https://blog.crowdaa.com',
    legacyCrowdUrl: 'https://crowd.crowdaa.com',
  },
  'crowdaa-fr': {
    name: 'prod-fr',
    countryCode: 'fr',
    apiUrl: 'https://api-fr.aws.crowdaa.com/v1',
    rootAppId: 'nQ9ZO9DEgfaOzWY44Xu2J2uaPtP92t176PpBkdqu',
    previewUrl: 'https://preview-app-fr.crowdaa.com',
    legacyDashboardUrl: 'https://blog-fr.crowdaa.com',
    legacyCrowdUrl: 'https://crowd-fr.crowdaa.com',
  },
};
